import React from 'react';

const VARIANTS = {
	blue: 'border-pd-blue-new text-pd-blue-new',
	red: 'border-pay-red text-pay-red',
};

/** Outlined pill button ("Manage Auto-Pay settings" / "Turn off Auto-Pay"). */
const OutlineButton = ({ children, onClick, variant = 'blue', disabled = false, type = 'button' }) => (
	<button
		type={type === 'submit' ? 'submit' : 'button'}
		disabled={disabled}
		onClick={onClick}
		className={`flex h-[52px] w-full shrink-0 cursor-pointer items-center justify-center rounded-full border-2 bg-white text-[15px] font-bold transition-colors hover:bg-pay-bg disabled:cursor-not-allowed disabled:opacity-50 ${VARIANTS[variant]}`}
	>
		{children}
	</button>
);

export default OutlineButton;
